import { ApiProperty } from "@nestjs/swagger";

export class InsuranceRequest{
    @ApiProperty()
    insuranceId: number;
    @ApiProperty()
    isActive: boolean;
    @ApiProperty()
    versionFlag: number;
    @ApiProperty()
    updatedUser: string;
}  